import { GetServerSideProps } from 'next';

import { getSharedPageData } from 'utils/shared-page-data';
import { logPersonalisationEvent } from 'utils/personalisation/personalisation';
import { parseQuickLinks } from 'lib/sanity/helpers/quickLinksHelper';
import { getHomePageData, INVALID_MARKET } from 'lib/sanity';
import HomePage from 'components/Homepage';
import { trackException } from 'utils/exceptionHandler';

import { sendCounterMetric, Whats } from '../../utils/metrics';
import { emptyChildCategoriesFilter } from '../../utils/sanity';

const getHomepageData = async (market: string) => {
  const homePageData = await getHomePageData(market);

  const quickLinks = parseQuickLinks(homePageData.quickLinks);
  // Hide the categories that have no subcategories
  const categories = homePageData.categories.filter(emptyChildCategoriesFilter);
  const banner = homePageData.banner;

  // FA-2473: Report when there are no Categories or Quick Links
  if (!categories.length || !quickLinks.length) {
    sendCounterMetric(Whats.MISSING_DATA, { page: 'home', market });
  }

  return { quickLinks, categories, banner };
};

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const market = query.market as string;
  const sharedPageData = await getSharedPageData(req, market);

  try {
    logPersonalisationEvent(req);
    const data = await getHomepageData(market);

    return { props: { data, sharedPageData } };
  } catch (error) {
    if (error.message === INVALID_MARKET) {
      return {
        notFound: true,
      };
    }
    trackException(error, 'home-page', market);
    // Homepage is allowed to fail: we simply render nothing but the search box
    return { props: { data: {}, sharedPageData } };
  }
};

export default HomePage;
